import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { updateTollTag } from "@/lib/api";
import { SearchBar } from "./SearchBar";
import { errMsg, normPlate, selectCls, truckFlags } from "./utils";

const FLAG_CLS = {
  Panne: "bg-red-600 text-white",
  Inactif: "bg-zinc-500 text-white",
  "Red tag": "status-red-tag",
  "Att. expert": "status-expert",
};

const TruckRow = ({ truck, tags, current, plateOf, onAssign }) => {
  const usable = tags.filter((t) => t.status === "actif" || t.id === current?.id);
  return (
    <div
      className={`grid grid-cols-[1fr_auto] md:grid-cols-[180px_1fr_220px] gap-3 items-center border bg-white px-4 py-3 ${current ? "border-zinc-300" : "border-amber-400 bg-amber-50/40"}`}
      data-testid={`toll-truck-row-${truck.license_plate}`}
    >
      <Link to={`/trucks/${truck.id}`} className="mono font-bold text-lg hover:text-[var(--ny-gold-deep)] transition-colors">
        {truck.license_plate}
      </Link>
      <div className="hidden md:flex gap-1 flex-wrap">
        {truckFlags(truck).map((f) => (
          <span key={f} className={`px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest ${FLAG_CLS[f]}`}>{f}</span>
        ))}
      </div>
      <select
        value={current?.id || ""}
        onChange={(e) => onAssign(truck, current, e.target.value)}
        className={`${selectCls} w-full`}
        data-testid={`toll-truck-select-${truck.license_plate}`}
      >
        <option value="">— Aucun télépéage —</option>
        {usable.map((t) => (
          <option key={t.id} value={t.id}>
            {`N°${t.number}${t.assigned_truck_id && t.assigned_truck_id !== truck.id ? ` (sur ${plateOf(t.assigned_truck_id)})` : ""}`}
          </option>
        ))}
      </select>
      <div className="flex md:hidden gap-1 flex-wrap col-span-2">
        {truckFlags(truck).map((f) => (
          <span key={f} className={`px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest ${FLAG_CLS[f]}`}>{f}</span>
        ))}
      </div>
    </div>
  );
};

export const TrucksView = ({ trucks, tags, reload }) => {
  const [q, setQ] = useState("");
  const byTruck = Object.fromEntries(tags.filter((t) => t.assigned_truck_id).map((t) => [t.assigned_truck_id, t]));
  const plateOf = (id) => trucks.find((t) => t.id === id)?.license_plate || "autre camion";
  const nq = normPlate(q);
  const list = trucks.filter((t) => t.status !== "rendu" && (!nq || normPlate(t.license_plate).includes(nq)));

  const assign = async (truck, current, tagId) => {
    try {
      if (tagId) await updateTollTag(tagId, { assigned_truck_id: truck.id });
      else if (current) await updateTollTag(current.id, { assigned_truck_id: null });
      toast.success(tagId ? `Télépéage attribué à ${truck.license_plate}` : `Télépéage retiré de ${truck.license_plate}`);
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div data-testid="toll-trucks-view">
      <SearchBar value={q} onChange={setQ} placeholder="Rechercher une plaque…" testId="toll-trucks-search" />
      <div className="space-y-2">
      {list.length === 0 && <div className="text-sm text-zinc-500" data-testid="toll-trucks-empty">{nq ? "Aucun camion trouvé." : "Aucun camion DLP4."}</div>}
      {list.map((t) => (
        <TruckRow key={t.id} truck={t} tags={tags} current={byTruck[t.id]} plateOf={plateOf} onAssign={assign} />
      ))}
      </div>
    </div>
  );
};
